import React from 'react';
import WithLoading from '../../../Hoc/WithLoading';
import BabyfaceView from './BabyfaceView';
import { getBabyfaceItemApi } from './BabyfaceAPI';
import PageTemplate from '../../../components/common/template/PageTemplate';

const Babyface = () => {
  return (
    <PageTemplate noMargin>
      <WithLoading component={BabyfaceView} url={getBabyfaceItemApi} />
    </PageTemplate>
  );
};

export default React.memo(Babyface);
